export default __webpack_public_path__ + "static/automobile-video-wall-6f98dea252d12f21080a4fd68e03e436.gif";